
<script>
import request from "./request.vue";
import session from "./session.vue";
import env from "../config/prod.env.js";

// const local = 'http://localhost:3000/api'

export default {
  search: async function(data = '', page, limit, filter = '') {
    if (data && data.length > 0) data.split(" ").join("%20");
    try {
      // const resp =  await request.send(`${env.ROOT_API}/parts/search?query=${data}`, {}, false, 'get');
      const resp = await request.send(
        `${env.ROOT_API}/parts/partindexsearch?query=${data}&page=${page}&limit=${limit}&${filter}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getFilters: async function(data = '', filter = '') {
    if (data && data.length > 0) data.split(" ").join("%20");
    try {
      // const resp =  await request.send(`${env.ROOT_API}/parts/search?query=${data}`, {}, false, 'get');
      const resp = await request.send(
        `${env.ROOT_API}/parts/partsFilters?query=${data}&${filter}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getWithFilters: async function(page, limit, filter = '') {
    try {
      const resp =  await request.send(`${env.ROOT_API}/parts/partsWithFilters?page=${page}&limit=${limit}&${filter}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getAllFilters: async function() {
    try {
      const resp =  await request.send(`${env.ROOT_API}/parts/partsAllFilters`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getFeatureHome: async function() {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/parts/homefeature`,
        {},
        false,
        "get"
      );
      resp.data.urlImage = "https://static.japanparts.com.br";
      return resp.data;
    } catch (error) {
      console.log(error);
    }
  },
  getManufacturers: async function() {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_manufacturers`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getCategories: async function() {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_categories`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getSubCategories: async function() {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_subcategories`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getByCode: async function(code) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/parts?filter[where][code]=${code}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getById: async function(id) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/parts?filter[where][id]=${id}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getDimensions: async function(id) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_dimensions?filter[where][part_id]=${id}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getVehicles: async function(partId) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/vehicles/findByPartId?partId=${partId}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  getEquivalences: async function(id) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_equivalences/findall?partId=${id}`,
        {},
        false,
        "get"
      );
      return resp.data;
    } catch (error) {
      console.log(error);
    }
  },
  getImages: async function(id) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_images?filter[where][part_id]=${id}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  },
  get: async function(id) {
    try {
      const resp = await request.send(
        `${env.ROOT_API}/part_dimensions?filter[where][part_id]=${id}`,
        {},
        false,
        "get"
      );
      return resp;
    } catch (error) {
      console.log(error);
    }
  }

  // get: async function() {
  //   try {
  //     const resp =  await request.send(``, {}, false, 'get');
  //     return resp;
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// src/api/part.vue